import React from 'react';
import AccountAdvVoucherRptFormView from '../../../../components/account/report/advanc_voucher_rpt/AccountAdvVoucherRptFormView';

const AdvancedReportFormView = () => {
  return (
    <AccountAdvVoucherRptFormView />
  )
}

export default AdvancedReportFormView